import React, { Fragment, useEffect } from "react";
import { Row, Col, Typography, Button } from "antd";
import { InputField } from "../../../../../../atoms/FormElement";
import { InputNumberFieldV2 as InputNumberField } from "../../../../../../atoms/FormElement/InputNumberField";

const { Text } = Typography;

export default (props) => {
  const { control, setValue, addPlans } = props; //fees

  const userData: any = localStorage?.getItem("login-response");
  let jsonUserData = JSON.parse(userData);

  useEffect(() => {
    addPlans?.forEach((item, index) => {
      setValue(`plan[${index}].annualRent`, Number(item?.annualRent));
      setValue(`plan[${index}].noOfYear`, Number(item?.noOfYear));
      setValue(`plan[${index}].securityDeposit`, Number(item?.securityDeposit));
    });
  }, [addPlans, setValue]);

  return (
    <>
      <Row gutter={[24, 24]}>
        <Col span={12}>
          <Text className="fontWeight600 ag-default mb-1">NO OF PAYMENTS</Text>
        </Col>
        <Col span={4}>
          <Text className="fontWeight600 ag-default mb-2">ANNUAL RENT</Text>
        </Col>
        <Col span={4}>
          <Text className="fontWeight600 ag-default mb-2">NUMBER OF YEARS</Text>
        </Col>
        <Col span={4}>
          <Text className="fontWeight600 ag-default mb-2">SECURITY DEPOSIT</Text>
        </Col>
      </Row>
      <Row gutter={[24, 24]} className="bf-main">
        <Col span={24} className="ft-divider" />
        {addPlans?.map((item, index) => (
          <Fragment key={index + item?.installments}>
            <Col span={12}>
              <Row>
                <Col span={6}>
                  <Text className="ag-dark fontWeight600" style={{ fontSize: "14px" }}>
                    {item.installments} Cheques
                  </Text>
                </Col>
                <Col span={6}>
                  <InputField
                    classes="fm-input-hidden"
                    fieldname={`plan[${index}]`}
                    control={control}
                    initValue={item}
                    iProps={{ readOnly: true, type: "hidden" }}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={4}>
              <InputNumberField
                label=""
                fieldname={`plan[${index}].annualRent`}
                control={control}
                inputNumberProps={{ precision: 2 }}
              />
            </Col>
            <Col span={4}>
              <InputNumberField
                label=""
                fieldname={`plan[${index}].noOfYear`}
                control={control}
              />
            </Col>
            <Col span={4}>
              <InputNumberField
                label=""
                fieldname={`plan[${index}].securityDeposit`}
                control={control}
                inputNumberProps={{ precision: 2 }}
              />
            </Col>
          </Fragment>
        ))}
      </Row>
      <Row justify="end" style={{ marginBottom: 20 }}>
        <Col>
          {/* {props?.handleDone && ( */}
          <InputField
            classes="fm-input-hidden"
            fieldname="furnished"
            control={control}
            initValue="yes"
            iProps={{ readOnly: true, type: "hidden" }}
          />
          {jsonUserData?.usertype?.includes("institutionalLandlord") && (
            <Button className="bf-button" htmlType="submit">
              Save
            </Button>
          )}
          {/* )} */}
        </Col>
      </Row>
    </>
  );
};
